import { render } from "./Status.vue?vue&type=template&id=5b01b37d&scoped=true"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"

import "./Status.vue?vue&type=style&index=0&id=5b01b37d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src801691255/src/serverlesspressoV3/frontends/vue-order-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b01b37d"]])

export default __exports__